export const DOMAIN = 'http://b.easteat.com'
export const SIGN = 'easteat_'
export const BAIDU_MAP_JS_PATH = 'http://api.map.baidu.com/api?v=2.0&ak=Uxo8T2xTOARG6vdxk9wasqP4F56PqTfI&callback=__initBaiduMap'
export const AUTH_KEY = 'easteat_auth_b'



// WEBPACK FOOTER //
// ./src/assets/js/config.js